module.exports = __webpack_public_path__ + "img/step.c311cb78.png";